import axios from "axios";
import JsCookie from "js-cookie";
import { Router } from "@al/next/router";
import { createTracker, V4_UPLOAD_DOMAIN, V4_EU_UPLOAD_DOMAIN } from "@al/event-tracking";
import BridgeV2 from "@akulaku/web-bridge";
import { LocalTimeService } from "@al/base-lib";

import AppType from "../enums/AppType";
import getAppName from "../utils/getAppName";

export const tracker = createTracker();
const IsProduction = process.env.BUILD_ENV === "prod";

const ASIA_API_DOMAIN = "ec-api.akulaku.com";
const EU_API_DOMAIN = "api.silvrr.com";
const AkulakuServerUrl = IsProduction
  ? "https://sc.akulaku.com/sa?project=production"
  : "https://sc.akulaku.com/sa?project=default";
const SilvrrServerUrl = IsProduction
  ? "https://datasinksc.wisecartapp.com/sa?project=production"
  : "https://datasinksc.wisecartapp.com/sa?project=default";

export const APP_TRACKER_CONFIG = {
  [AppType.Akulaku]: {
    appBrand: "aku",
    uploadDomain: V4_UPLOAD_DOMAIN,
    apiDomain: ASIA_API_DOMAIN,
    prefix: "Aku",
    appName: "Akulaku",
    serverUrl: AkulakuServerUrl,
    sessionIdKey: "self_session_id",
  },
  [AppType.Silvrrplus]: {
    appBrand: "sil",
    uploadDomain: V4_UPLOAD_DOMAIN,
    apiDomain: ASIA_API_DOMAIN,
    prefix: "Aku",
    appName: "Silvrr+",
    serverUrl: AkulakuServerUrl,
    sessionIdKey: "self_session_id",
  },
  [AppType.Silvrr]: {
    appBrand: "wca",
    uploadDomain: V4_EU_UPLOAD_DOMAIN,
    apiDomain: EU_API_DOMAIN,
    prefix: "Wca",
    appName: "Silvrr",
    serverUrl: SilvrrServerUrl,
    sessionIdKey: "session_id",
  },
};

export function initTracker(): void {
  const appType = getAppName();
  tracker.init({
    storeName: "akulaku",
    common: {
      env: process.env.BUILD_ENV || "local",
      countryId: JsCookie.get("countryId"),
      countryCode: JsCookie.get("countryCode"),
      routeHooks: {
        leave: (): void => {
          Router.events.on("routeChangeStart", () => {
            tracker.leave({ behavior: { v4: {} }, sa: {} });
          });
        },
      },
      localTimeService: (): any => {
        return new LocalTimeService(() => {
          // 对钟逻辑
          return new Promise((resolve, reject) => {
            const url = `https://${process.env.BUILD_ENV === "prod" ? "" : "test-"}${
              APP_TRACKER_CONFIG[appType]?.apiDomain || ASIA_API_DOMAIN
            }/aapi/time/now`;
            axios
              .get(url)
              .then((res) => {
                if (res.data.success) {
                  resolve({
                    sysTime: res.data.sysTime,
                  });
                } else {
                  reject();
                }
              })
              .catch((err) => {
                reject(err);
              });
          });
        });
      },
    },
    sa: {
      showLog: !IsProduction,
      enabled: true,
      serverUrl: APP_TRACKER_CONFIG[appType]?.serverUrl || APP_TRACKER_CONFIG[AppType.Akulaku].serverUrl,
      autoTrack: false,
      prefix: APP_TRACKER_CONFIG[appType]?.prefix || APP_TRACKER_CONFIG[AppType.Akulaku].prefix,
      appName: APP_TRACKER_CONFIG[appType]?.appName || APP_TRACKER_CONFIG[AppType.Akulaku].appName,
      sessionIdKey: APP_TRACKER_CONFIG[appType]?.sessionIdKey || APP_TRACKER_CONFIG[AppType.Akulaku].sessionIdKey,
    },
    behavior: {
      v4: {
        enableLog: process.env.BUILD_ENV === "local",
        appName: "akulaku",
        isNative: BridgeV2.isAkulaku(),
        appBrand: APP_TRACKER_CONFIG[appType]?.appBrand || APP_TRACKER_CONFIG[AppType.Akulaku].appBrand,
        uploadDomain: APP_TRACKER_CONFIG[appType]?.uploadDomain || APP_TRACKER_CONFIG[AppType.Akulaku].uploadDomain,
        nativeLogHandler: (data: Array<any>): Promise<void> => {
          return new Promise((resolve, reject) => {
            // window.JsBridge = BridgeV2;
            data = (data || []).map((d) => ({
              ...d,
              sn: Number(d.sn),
            }));

            if (BridgeV2.reportActionLogV4) {
              BridgeV2.reportActionLogV4({ datas: data });
              resolve(undefined);
            } else {
              reject();
            }
          });
        },
      },
    },
  });
}
